import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout } from "../../components/cards";
import { Breadcrumb } from "../../components";
import { StockHistory, YardInfo } from "../../components/stock";
import { YardActions } from "../../components/stock/YardActions";
import { StockService } from "../../services";

export const SingleYard = () => {
  const { id } = useParams();

  const [yardInfo, setYardInfo] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = () => {
    setLoading(true);
    const yardDetails = StockService.getYard(Number(id));
    setYardInfo(yardDetails);
    setLoading(false);
  };

  const handleAddStock = () => {
    navigate(`/vendor/purchase/add?yardId=${id}`);
  };

  const handleMoveStock = () => {
    navigate("/MoveStock", { state: { yardId: Number(id) } });
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title={"Yard Details"} />
          </CardLayout>
        </Col>
        <Col xl={6}>
          <YardInfo
            yard={yardInfo}
            handleEdit={() => {
              alert("Edit");
            }}
            handleDelete={() => {
              alert("Delete");
            }}
          />
        </Col>

        <Col xl={6}>
          <YardActions
            handleAddStock={handleAddStock}
            handleMoveStock={handleMoveStock}
            handleDownloadReport={() => alert("Download Report")}
          />
        </Col>

        <Col xl={12}>
          <CardLayout>
            <StockHistory id={id} />
          </CardLayout>
        </Col>
      </Row>
    </PageLayout>
  );
};
